import React from 'react';

const renderTable = (headers, data, checkbox, openDocumentDetails) => {
    let header = "";
    let body = "";
    if (Array.isArray(headers) && headers.length > 0) {
        header = 
        <tr>
            <td className="sticky-column text-center" style={{backgroundColor: "#e9ecef"}}>
                <input type="checkbox" onChange={(event) => checkbox.selectAll(event.target.checked)}/>
            </td>
            {headers.filter((({value}) => value === true)).map(header =>  <td>{header.title}</td>)}
            <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>Acciones</td>

        </tr>;
    }

    if (Array.isArray(data) && data.length > 0) {
        body = data.map((register, index) =>
            <tr>
                <td className="sticky-column text-center">
                    <input type="checkbox" checked={!!checkbox.data.get(index)} onChange={() => checkbox.selectOne(index)}/>
                </td>
                {headers.filter((({value}) => value === true)).map(header =>  
                    <td className={header.classes}>{!!header.format ? header.format(register[header.field]) : register[header.field]}</td>
                )}
                <td className="sticky-columns" style={{backgroundColor: "#e9ecef"}}>
                    <button type="button" className="btn btn-timbra-one btn-sm botonCorrect"
                            onClick={() => openDocumentDetails(register.DocEntry)}
                            style={{fontWeight: '500'}}>
                        <i className="far fa-file-alt">
                        </i> Ver Detalles
                    </button>
                </td>
            </tr>
        );
    }

    let table =
        <table id="dataTableTimbra" className="display" style={{width: '100%'}}>
            <thead className="table-header"> {header} </thead>
            <tbody> {body} </tbody>
        </table>;

    return table;
};

export const renderTableInventoryDocuments = (headers, data, checkbox, openDocumentDetails) => { return renderTable(headers, data, checkbox, openDocumentDetails); }